import { createContext } from 'react'

type RouteAnimationContextType = {
  isAnimationRun: boolean
  setAnimationRun: React.Dispatch<React.SetStateAction<boolean>>
  isAnimationHalfLife: boolean
  setAnimationHalfLife: React.Dispatch<React.SetStateAction<boolean>>
}

const RouteAnimationContext = createContext<RouteAnimationContextType>({
  isAnimationRun: false,
  setAnimationRun: value => {},
  isAnimationHalfLife: false,
  setAnimationHalfLife: value => {},
})

export default RouteAnimationContext
